import React, { useState } from 'react';
import axios from 'axios';
import './ResetPassword.css';
import config from '../../config';

axios.defaults.baseURL = config.BASE_URL;

const ResetPassword = ({ onClose }) => {
    const [username, setUsername] = useState('');
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [retypePassword, setRetypePassword] = useState('');
    const [showPassword, setShowPassword] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!username || !currentPassword || !newPassword || !retypePassword) {
            alert('Please fill all fields');
            return;
        }

        if (newPassword !== retypePassword) {
            alert('Passwords do not match');
            return;
        }

        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()+_\-={}\[\]|:;"<>,.?/])[A-Za-z\d!@#$%^&*()+_\-={}\[\]|:;"<>,.?/]{8,}$/;

        if (!passwordRegex.test(newPassword)) {
            alert('Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.');
            return;
        }

        try {
            const response = await axios.post('/reset-password', 
                { username, currentPassword, newPassword, retypePassword },
                {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );
            onClose();

            setTimeout(() => {
                alert(response.data.message);
            }, 500);

        } catch (error) {
            if (error.response.data.message) {
                alert(error.response.data.message);
            }
            else {
                alert('Error updating the password');
            }
        }
    }

    return (
        <div className='modal-overlay'>
            <div className='modal-content'>
                <h2>Reset Password</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-control">
                        <label htmlFor="username">Username:</label>
                        <input
                            type="text"
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-control">
                        <label htmlFor="currentPassword">Current Password:</label>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            id="currentPassword"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-control">
                        <label htmlFor="newPassword">New Password:</label>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            id="newPassword"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-control">
                        <label htmlFor="retypePassword">Retype New Password:</label>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            id="retypePassword"
                            value={retypePassword}
                            onChange={(e) => setRetypePassword(e.target.value)}
                            required
                        />
                    </div>

                    <span
                        className='pass-display'
                        onClick={() => setShowPassword(!showPassword)}
                    >
                        {showPassword ? 'Hide password' : 'Show password'}
                    </span>

                    <div className="modal-buttons">
                        <button type="submit" className="reset-button" >Reset Password</button>
                        <button type="button" className="cancel-button" onClick={onClose}>
                            Cancel
                        </button>
                    </div>
                </form>
            </div>


        </div>
    )
}

export default ResetPassword
